import { useCallback } from 'react';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';
import { MaybeLoanID } from 'src/common/types';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import { useBasicToast } from '../useBasicToast';
import { FIRST_PARTY_QUICKAPP_UTM_PARAMS, FIRST_PARTY_FULLAPP_UTM_PARAMS } from '../../modules/Upsell/constants';

export const SendToFirstPartyExperienceError = createDatadogError('SendToFirstPartyExperience');

const isQuickAppURL = (url: string): boolean => url.includes('/quickapp/');

export const useSendToFirstParty = (loanID: MaybeLoanID, borrower_id: string | null) => {
    const sendToast = useBasicToast();
    const sendToFirstParty = useCallback(
        async (firstPartyURL: string | null) => {
            if (!firstPartyURL) {
                await DatadogRUMService.Client.getInstance().addError(
                    new SendToFirstPartyExperienceError('First party app URL is not available'),
                    {
                        borrower_id,
                        loanID,
                        nextDestination: firstPartyURL,
                    }
                );
                sendToast('We were unable to access your application. Please call your LO.', 'critical');
                return;
            }
            const utmParams = isQuickAppURL(firstPartyURL)
                ? FIRST_PARTY_QUICKAPP_UTM_PARAMS
                : FIRST_PARTY_FULLAPP_UTM_PARAMS;
            const firstPartyURLWithUTM = ZillowHomeLoansURL.appendUTMParamsToURL(firstPartyURL, utmParams);
            await DatadogRUMService.Client.getInstance().addAction(
                DatadogRUMService.CustomAction.DASHBOARD_START_FIRST_PARTY_EXPERIENCE_SUCCESS,
                {
                    borrower_id,
                    loanID,
                    nextDestination: firstPartyURLWithUTM,
                }
            );

            window.location.assign(firstPartyURLWithUTM);
        },
        [borrower_id, sendToast, loanID]
    );

    return {
        sendToFirstParty,
    };
};
